
export const subCategoryService = (subCategoryService) => {
    switch (subCategoryService) {
        case "InstaDefault":
            return "Insta";
        case "InstaImages":
        case "InstaComments":
        case "InstaCustomComments":
        case "InstaVideo":
            return "Insta";
        case "FacebookPage":
        case "FacebookPosts":
        case "FacebookVideo":
        case "FacebookComment":
        case "FacebookCustomComment":
        case "FacebookProfile":
        case "FacebookDefault":
            return "Facebook";
        case "TwitterFollow":
            return "Twitter";
        case "YoutubeVideo":
        case "YoutubeCustomComments":
        case "YoutubeChannel":
            return "Youtube";
        case "SoundCloudTrack":
        case "SoundCloudArtist":
            return "SoundCloud";
        case "TikTokProfile":
            return "TikTok";
        case "TikTokPost":
        case "TikTokComments":
        case "TikTokCustomComments":
            return "TikTok";
        default:
            break;
    }
}
